import { useDashboardStatisticsQuery } from '@queries';
import { useOrdersStatisticsQuery } from '@hooks/useOrdersQuery/useOrdersStatisticsQuery';
import { getProfit, getShopStageObject } from './utils';
const staleTime = 60_000; // 1 minute
export const useShopStage = () => {
    const { dashboardStatisticsQuery } = useDashboardStatisticsQuery(undefined, { staleTime });
    const { getOrdersStatisticsQuery } = useOrdersStatisticsQuery([{ types: ['COMMON'] }], {
        staleTime,
    });
    const getShopStage = () => {
        const profit = getProfit(dashboardStatisticsQuery.data);
        return getShopStageObject(profit, getOrdersStatisticsQuery?.data?.value);
    };
    return { shopStage: getShopStage() };
};
